import { CONFIG } from 'configs/index';
export const parsedBaseUrl = CONFIG.API.FrontDoor.split('/').slice(0, 3).join('/');
class API {
    public static FinanceConfig = {
        GetCustomerToggles: `${parsedBaseUrl}/finopsconfig/CustomerToggles`,
        Printers: `${parsedBaseUrl}/finopsconfig/printers`,
        InvoiceOutputTypes: `${parsedBaseUrl}/finopsconfig/invoiceoutputtypes`,
        ReasonCodes: `${parsedBaseUrl}/finopsconfig/reasoncodes`,
        VatPartners: `${parsedBaseUrl}/finopsconfig/vatpartner`,
        Materials: `${parsedBaseUrl}/finopsconfig/materials`,
        DocumentStatus: `${parsedBaseUrl}/finopsconfig/documentstatus`,
        MaterialCodeAdditionalAttributes: `${parsedBaseUrl}/finopsconfig/materialcodeadditionalattribute`,
        ChargeAmendmentExceptions: `${parsedBaseUrl}/finopsconfig/chargeammendmentexceptionlists`,
        AthenaOptionalChargeRateRetrieval: `${parsedBaseUrl}/finopsconfig/athenaoptionalchargerateretrieval`,
        ChargeSplitRules: `${parsedBaseUrl}/finopsconfig/chargesplitrules`,
        GetCustomerCodes: `${parsedBaseUrl}/finopsconfig/companycodes`,
        GcaConfiguration: `${parsedBaseUrl}/finopsconfig/gca`,
    };
    public static UAM = {
        GetCTBusinessFunctions: `${CONFIG.API.ContainerTracking}/GetUAMBusinessFunctionsForUserToken`,
        GetCustomsBusinessFunctions: `${CONFIG.API.Customs}/GetUAMBusinessFunctionsForUserToken`,
        GetDPBusinessFunctions: `${CONFIG.API.DeliveryPlanning}/GetUAMBusinessFunctionsForUserToken`,
        GetRoles: `${CONFIG.API.Uaminfo}/uamInfo`,
        GetRolesUamV4: `${CONFIG.API.FrontDoor}/finops-export/uamInfo`,
        GetPermission: `${CONFIG.API.FrontDoor}`,
    };
    public static Booking = {
        GetBookings: `${CONFIG.API.FrontDoor}/GetBookings`,
        BookingDetails: `${CONFIG.API.FrontDoor}/finops-export/bookings`,
    };
    public static CBL = {
        CblSearch: `${CONFIG.API.FrontDoor}/finops-export/cbls/search`,
        CblDetails: `${CONFIG.API.FrontDoor}/finops-export/cbls`,
    };
    public static ETS = {
        GetDetails: `${CONFIG.API.FrontDoor}/ets`,
        GetUploadedChargeLogs: `${CONFIG.API.FrontDoor}/finops-export/bulk-upload/charges-logs`,
        GetDownloadLogs: `${CONFIG.API.FrontDoor}/finops-download/logs`,
        UploadChargeItems: `${CONFIG.API.FrontDoor}/charge-items/upload`,
        DownloadChargeItems: `${CONFIG.API.FrontDoor}/finops-download/ets/charges`,
        DownloadStatus: `${CONFIG.API.FrontDoor}/finops-download/status`,
        DownloadFile: `${CONFIG.API.FrontDoor}/finops-download`,
        DownloadFileSummary: `${CONFIG.API.FrontDoor}/finops-download/summary`,
        EtsSearch: `${CONFIG.API.FrontDoor}/finops-import/ets/search`,
        ExportJobEtsDetails: (id: number) => `${CONFIG.API.FrontDoor}/finops-import/export-jobs/${id}/ets`,
        EtsAdHocContractualRates: `${CONFIG.API.FrontDoor}/finops-import/AdHocContractalRates/get`,
        SendCreateSalesOrderImport: `${CONFIG.API.FrontDoor}/finops-import/ets/salesOrder/create`,
        NftpRouter: `${CONFIG.API.FrontDoor}/finops-import/nftp/router`,
    };
    public static FCR = {
        GetData: `${CONFIG.API.FrontDoor}/GenericSearchFCRs`,
        GetFcrDetails: `${CONFIG.API.FrontDoor}/fcrs`,
        FcrSearch: `${CONFIG.API.FrontDoor}/finops-export/fcrs/search`,
        FcrDetails: `${CONFIG.API.FrontDoor}/finops-export/fcrs`,
    };
    public static ExportJob = {
        ExportJobSearch: `${CONFIG.API.FrontDoor}/finops-export/export-jobs/search`,
        GetExportJobDetails: `${CONFIG.API.FrontDoor}/export-jobs`,
        GetExportJobDropdown: `${CONFIG.API.FrontDoor}/documents/statuses`,
        DownloadChargeItems: `${CONFIG.API.FrontDoor}/finops-download/exportjob/charges`,
        GetReconciliationPODetails: `${CONFIG.API.FrontDoor}/reconciliation/po-details`,
        ExportJobDetail: `${CONFIG.API.FrontDoor}/finops-export/export-job`,
        ExportJobsDetail: `${CONFIG.API.FrontDoor}/finops-export/export-jobs`,
        ExportJobsAdhocContractualRates: `${CONFIG.API.FrontDoor}/finops-export/adhoc-contractualrates/get`,
        SendCreateSalesOrderExport: `${CONFIG.API.FrontDoor}/finops-export/export-jobs/salesOrder/create`,
        NftpRouter: `${CONFIG.API.FrontDoor}/finops-export/nftp/router`
    };
    public static Equipment = {
        GetEquipmentDetails: `${CONFIG.API.FrontDoor}/equipments`,
        EquipmentSearch: `${CONFIG.API.FrontDoor}/finops-export/equipment/search`,
        EquipmentDetails: `${CONFIG.API.FrontDoor}/finops-export/equipments`,
    };
    public static MDM = {
        CheckCode: `${CONFIG.API.FrontDoor}/mdm/customers`,
    };
    public static Search = {
        GetJobCosting: `${CONFIG.API.FrontDoor}/GenericSearch`,
    };
    public static SAP = {
        GetPdf: `${CONFIG.API.ViewPdf}/erp-ls/opentext/doc-url`,
        ResendMessage: `${CONFIG.API.FrontDoor}/resend`,
    };
    public static Invoices = {
        GetData: `${CONFIG.API.FrontDoor}/GetFCRs`,
        GetEtsData: `${CONFIG.API.FrontDoor}/GetETSIssueInvoice`,
        SendData: `${CONFIG.API.FrontDoor}/invoices`,
        SendCreditNote: `${CONFIG.API.FrontDoor}/AddBillingCreditNote`,
        GetInvoiceDetails: `${CONFIG.API.FrontDoor}/GetInvoiceDetails`,
        GetISSODetails: `${CONFIG.API.FrontDoor}/invoices/isso`,
        GetInvoiceHistory: `${CONFIG.API.FrontDoor}/GetInvoiceDetailsHistory`,
        SendReprint: `reprint`,
        GetDownload: `${CONFIG.API.FrontDoor}/invoices/download`,
        GetPDFDownload: `${CONFIG.API.FrontDoor}/invoices/download`,
        OriginInvoiceSearch: `${CONFIG.API.FrontDoor}/finops-export/invoices/origin/search`,
        DestinationInvoiceSearch: `${CONFIG.API.FrontDoor}/finops-import/invoices/destination/search`,
        CustomerInvoiceSearch: `${CONFIG.API.FrontDoor}/finops-export/invoices/search`,
        getReprintDownloadStatusViewOrigin: `${CONFIG.API.FrontDoor}/finops-export/invoices/origin/reprintOrDraft`,
        getReprintDownloadStatusViewDest: `${CONFIG.API.FrontDoor}/finops-import/invoices/destination/reprintOrDraft`,
        ValidateInvoice: `${CONFIG.API.FrontDoor}/invoices/validate`,
    };
    public static CostRevenue = {
        GetCostAndRevenue: `${CONFIG.API.FrontDoor}/GetCostAndRevenue`,
        GetETSCostRev: `${CONFIG.API.FrontDoor}/ets/charges`,
        UpdateCharges: `${CONFIG.API.FrontDoor}/SalesOrderOperationTrigger`,
        RefreshAthenaRates: `${CONFIG.API.FrontDoor}/RefreshAthenaRatesTrigger`,
        AddCostAndRevenue: `${CONFIG.API.FrontDoor}/AddCostAndRevenue`,
        GetCustomerMaster: `${CONFIG.API.FrontDoor}/customerMaster`,
    };
    public static CostRevenueNew = {
        GetDistributionData: (id: number) =>
            `${CONFIG.API.FrontDoor}/finops-export/cbl/${id}/rate-details/distributions`,
        getJobStatus: (id: number) =>
            `${CONFIG.API.FrontDoor}/finops-export/cbl/${id}/validate-job-status`,
        getCostRevenueData: `${CONFIG.API.FrontDoor}/finops-export/cbl`,
        saveCostData: `${CONFIG.API.FrontDoor}/finops-export/cbl/cost-items`,
        saveRevenueData: `${CONFIG.API.FrontDoor}/finops-export/cbl/revenue-items`,
        getExportJobsCharge: `${CONFIG.API.FrontDoor}/finops-export/cblChargeItems`,
        getEquipmentDetails: `${CONFIG.API.FrontDoor}/finops-export/cblChargeItems`,
        getCBLEditStatus: `${CONFIG.API.FrontDoor}/finops-export/cbl/ValidateJobAndChargeItemsStatus`,
        getRevChargeItemEdit: `${CONFIG.API.FrontDoor}/finops-export/cbl-revenue-items/distribution`,
        getCostChargeItemEdit: `${CONFIG.API.FrontDoor}/finops-export/cbl-cost-items/distribution`,
        getRevChargeItemDelete: `${CONFIG.API.FrontDoor}/finops-export/cbl/revenue-items`,
        getCostChargeItemDelete: `${CONFIG.API.FrontDoor}/finops-export/cbl/cost-items`,
        getSalesOrders: `${CONFIG.API.FrontDoor}/finops-export/export-jobs`,
        getEquipmentsHeader: `${CONFIG.API.FrontDoor}/finops-export/equipments`,
        ImportChargeItemsAuditLogs: (id: string) => `${CONFIG.API.FrontDoor}/finops-import/ets/${id}/charge-items/audit-logs`,
    };
    public static EXCEPTION = {
        GetData: `${CONFIG.API.FrontDoor}/error-logs`,
        GetLogs: `${CONFIG.API.FrontDoor}/GetInterfaceLogs`,
        GetReprocessLogs: `${CONFIG.API.FrontDoor}/ReprocessingRequestLogs`,
        GetCount: `${CONFIG.API.FrontDoor}/GetNotificationCount?ReferenceId=`,
        GetNotifications: `${CONFIG.API.FrontDoor}/notification-logs`,
        SetUpdate: `${CONFIG.API.FrontDoor}/UpdateNotification`,
        InterfaceLogSearch: `${CONFIG.API.FrontDoor}/finops-export/interface-logs/search`,
        ReprocessLogSearch: `${CONFIG.API.FrontDoor}/finops-export/reprocess-logs/search`,
        BulkDownloadOpenExceptions: `${CONFIG.API.FrontDoor}/finops-download/error-logs`,
    };
    public static DASHBOARD = {
        REPORTS: `${CONFIG.API.FrontDoor}/Reports`,
        REPORTS_NO_INVOICED_FCR: `${CONFIG.API.FrontDoor}/Reports/FCRNotInvoiced`,
        REPORTS_NO_INVOICED_ETS: `${CONFIG.API.FrontDoor}/Reports/ETSNotInvoiced`,
        SUMMARY: `${CONFIG.API.FrontDoor}/GetCBLDetails`,
    };
    public static Partners = {
        GetViewPartners: `${CONFIG.API.FrontDoor}/GetViewPartners`,
    };
    public static Vendors = {
        GetVendors: `${CONFIG.API.FrontDoor}/vendors`,
    };
    public static HistoryLogs = {
        GetHistoryLogByShipmentId: `${CONFIG.API.FrontDoor}/historylogs`,
        GetHistoryLogCostAndRevenueByShipmentId: `${CONFIG.API.FrontDoor}/CostAndRevenueHistory`,
        GetHistoryLogCostAndRevenueByShipmentIdNew: `${CONFIG.API.FrontDoor}/finops-export/costAndRevenueHistory`,
        GetBlob: `${CONFIG.API.FrontDoor}/historylog/`,
        GetBlobReprocess: `${CONFIG.API.FrontDoor}/ReprocessingBlobFile?Id=`,
        GetBlobBulkUpload: `${CONFIG.API.FrontDoor}/bulkupload-errorlogs/`,
        HistoryLogs: `${CONFIG.API.FrontDoor}/finops-export/historylogs`,
    };
    public static ExtraDocument = {
        SearchExportExtraDocumentConfiguration: `${CONFIG.API.FrontDoor}/extra-documents/esso/search`,
        SearchImportExtraDocumentConfiguration: `${CONFIG.API.FrontDoor}/extra-documents/isso/search`,
        ExportExtraDocumentConfiguration: `${CONFIG.API.FrontDoor}/extra-documents/esso`,
        ImportExtraDocumentConfiguration: `${CONFIG.API.FrontDoor}/extra-documents/isso`,
        ToggleExtraDocumentConfiguration: `${CONFIG.API.FrontDoor}/extra-documents/toggle`,
        ExtraDocumentConfiguration: `${CONFIG.API.FrontDoor}/extra-documents`,
        EssoRates: `${CONFIG.API.FrontDoor}/migrated-esso-rates`,
        extraDocImport: `${CONFIG.API.FrontDoor}/finops-import/extra-document/etsList`,
        processExtraDocImport: `${CONFIG.API.FrontDoor}/finops-import/extra-document`,
        extraDocExport: `${CONFIG.API.FrontDoor}/finops-export/extra-document/export-jobs`,
        processExtraDocExport: `${CONFIG.API.FrontDoor}/finops-export/extra-document`,
    };
    public static FeatureToggle = {
        GetFeatureTogglesData: `${CONFIG.API.FeatureManagementURL}`,
    };
    public static VatPartners = {
        updateVatPartnersIsso: `${CONFIG.API.FrontDoor}/finops-import/vat-partner/update`,
        updateVatPartnersEsso: `${CONFIG.API.FrontDoor}/finops-export/vat-partner/update`,
        fetchExportVatPartnerValue: `${CONFIG.API.FrontDoor}/finops-export/vat-partner/search`,
        fetchImportVatPartnerValue: `${CONFIG.API.FrontDoor}/finops-import/vat-partner/search`,
    };
    public static Notifications = {
        TopOpenNotifications: `${CONFIG.API.FrontDoor}/finops-export/notifications?ReferenceId=`,
        NotificationSearch: `${CONFIG.API.FrontDoor}/finops-export/notifications/search`,
    };
    public static PendingProcessingMessages = {
        GetPendingProcessingMessages: `${CONFIG.API.FrontDoor}/finops-export/reprocess-logs/pendingreasonmessages`,
    }
    public static Headers: object = {
        'Access-Control-Allow-Origin': '*',
        'api-version': '1.0',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
    };
    public static HeadersApiV2: object = {
        'Access-Control-Allow-Origin': '*',
        'api-version': '2',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
    };
    public static HeadersApiV3: object = {
        'Access-Control-Allow-Origin': '*',
        'api-version': '3',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
    };
    public static HeadersApiV1: object = {
        'Access-Control-Allow-Origin': '*',
        'api-version': '1',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
    };
    public static HeadersUploadExport: object = {
        'Access-Control-Allow-Origin': '*',
        'api-version': '2.0',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
    };
    public static HeadersExtraDocument: object = {
        'Access-Control-Allow-Origin': '*',
        'api-version': '2',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
    };
    public static HeadersFeatureToggle: object = {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
        'api-version': '1.0',
        'Application-Key': CONFIG.API.ApiKey,
    };
    public static HeadersUam: object = {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
        'api-version': '3.0',
        uam_version: 'V4',
        'Application-Key': CONFIG.API.ApiKey,
    };
    public static HeadersSettings: object = {
        'Application-Key': CONFIG.API.ApiKey,
        'Access-Control-Allow-Origin': '*',
        'api-version': '1.0',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
    };
}

export default API;
